import useFeatureEnabled from 'app/launch-darkly/use-feature-enabled';
import { FEATURE_FLAGS } from 'app/launch-darkly/featureFlags';

export default function useConsentCategorySelectEnabled() {
  const { configurableConsentMvpEnabled, ecmConfigurableConsentEnabled } = useFeatureEnabled(
    FEATURE_FLAGS.configurableConsentMvp,
    FEATURE_FLAGS.ecmConfigurableConsent
  );

  const consentCategorySelectEnabled = configurableConsentMvpEnabled && ecmConfigurableConsentEnabled;

  return { consentCategorySelectEnabled };
}
